import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { CContainer, CRow, CCol, CCard, CCardBody, CSpinner, CAlert } from '@coreui/react';
import { useTranslation } from 'react-i18next';

const EmailVerificationPage = () => {
    const { t } = useTranslation();
    const { uid, token } = useParams();
    const [verificationStatus, setVerificationStatus] = useState('pending'); // 'pending', 'success', 'error'
    const [message, setMessage] = useState(t('verification.pending'));

    useEffect(() => {
        if (uid && token) {
            const verifyEmail = async () => {
                try {
                    const response = await axios.get(`/api/verify-email/${uid}/${token}/`);
                    setVerificationStatus('success');
                    // Сообщение от бэкенда может быть на конкретном языке,
                    // но здесь мы доверяем переводу от бэкенда или перезаписываем своим успехом, если бэкенд возвращает только флаг.
                    // Если бэкенд возвращает строку, лучше использовать её, если она локализована на сервере.
                    // Если нет - можно использовать t('verification.success_backend')
                    setMessage(response.data.message);
                } catch (error) {
                    setVerificationStatus('error');
                    setMessage(error.response?.data?.error || t('verification.error_default'));
                }
            };
            verifyEmail();
        } else {
            setVerificationStatus('error');
            setMessage(t('verification.error_invalid_link'));
        }
    }, [uid, token, t]);

    const renderContent = () => {
        switch (verificationStatus) {
            case 'pending':
                return (
                    <div className="text-center">
                        <CSpinner color="primary" />
                        <p className="mt-3">{message}</p>
                    </div>
                );
            case 'success':
                return (
                    <CAlert color="success" className="text-center">
                        <h4>{message}</h4>
                        <p>{t('verification.wait_admin')}</p>
                        <p>{t('verification.write_manager')} <a href="https://t.me/neimarker" target="_blank" rel="noopener noreferrer">@neimarker</a>.</p>
                    </CAlert>
                );
            case 'error':
                 return <CAlert color="danger" className="text-center"><h4>{message}</h4></CAlert>;
            default:
                return null;
        }
    };

    return (
        <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
            <CContainer>
                <CRow className="justify-content-center">
                    <CCol md={6}>
                        <CCard className="p-4">
                            <CCardBody>
                                {renderContent()}
                                <div className="text-center mt-3">
                                  <Link to="/login">{t('verification.go_login')}</Link>
                                </div>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </div>
    );
};

export default EmailVerificationPage;